<template>
  <v-container>
    <v-layout column justify-space-around align-space-around>
      <v-flex>
        <h1>
          Give the
          {{ this.randomDeclensionPrompt | camelToSpacedCaps | lowercase }}
        </h1>
      </v-flex>
      <v-flex>
        <h1 class="display-4 font-weight-thin font-italic">
          {{ this.prompt.emiWord.toLowerCase() }}
        </h1>
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span>Cheat here</span>
            <v-icon v-on="on">chat</v-icon>
          </template>
          <span>{{ this.answers.join(" / ") }}</span>
        </v-tooltip> -->

        <v-flex>
          <a :href="'https://xn--lamh-bpa.org/glossary/' + this.wordWithoutAccents" target="_blank">See glossary entry</a>
        </v-flex>
      </v-flex>

      <v-flex ma-5>
        <v-form v-on:submit.prevent="onSubmit">
          <v-layout>
            <v-text-field
              label="Answer"
              ref="typeBox"
              v-model="userAnswer"
              autofocus
            ></v-text-field>
            <v-btn @click="handleSkip" v-if="!answered"> Skip </v-btn>
          </v-layout>
          <v-btn @click="handleAnswer" v-if="!answered">Check</v-btn>
          <v-btn @click="onSubmit" v-else>Next</v-btn>
        </v-form>
      </v-flex>

      <v-flex v-if="answered">
        <v-card flat width="80%">
          <v-container fill-height fluid>
            <v-card-text>
              <p class="green--text" style="font-size: 300%" v-if="correct">
                Correct!
              </p>
              <p class="red--text" style="font-size: 300%" v-else>Incorrect!</p>
              <p class="secondary--text" style="font-size: 150%">
                Correct Answers: {{ correctAnswer.join(" / ") }}
              </p>
            </v-card-text>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { PARTS_OF_SPEECH, GENDER, VOWELS } from "@/constants.js";
import { handleInitialMutationSingular } from "@/nouns.js";
export default {
  name: "NounQuestion",
  props: {
    prompt: Object,
  },
  data() {
    return {
      userAnswer: "",
      correct: false,
      answered: false,
      correctAnswer: "",
    };
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        const theElement = this.$refs.typeBox.$el;
        const input = theElement.querySelector(
          "input:not([type=hidden]),textarea:not([type=hidden])"
        );
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 0);
        }
      });
    },
    onSubmit() {
      if (!this.answered) this.handleAnswer();
      else this.clear();
    },
    handleAnswer: function () {
      this.answered = true;
      this.correctAnswer = this.answers;
      this.correct = this.checkDeclension();
      this.$emit("check", { answer: this.userAnswer, correct: this.correct });
      return;
    },
    handleSkip: function () {
      this.clear();
    },
    clear: function () {
      this.$emit("next");
      this.answered = false;
      this.userAnswer = "";
      this.correctAnswer = "";
      this.setFocus();
    },
    checkDeclension() {
      return this.answers.includes(this.userAnswer);
    },
    tsMethodSignature() {},
  },
  computed: {
    article() {
      if (this.partOfSpeech === PARTS_OF_SPEECH.noun) {
        let w = this.prompt.emiWord;
        let firstLetter = w.substring(0, 1);
        if (this.prompt && w) {
          //   if (VOWELS.indexOf(firstLetter) >= 0) return "an t-";
          return "an ";
        } else return "";
      } else return "";
    },
    //gender: 1 = masculine, 2 = feminine, 3 = masculine-feminine, 4 = none
    gender() {
      if (this.prompt.gender) return parseInt(this.prompt.gender);
      else return "";
    },
    wordDisplay() {
      return handleInitialMutationSingular(this.prompt);
    },
    answers() {
      let answer = this.declensions[this.randomDeclensionNumber];
      answer = answer.split(",");
      if (answer.length > 1) {
      }
      return answer;
    },
    answerArticle() {
      return "";
    },
    partOfSpeech() {
      return parseInt(this.prompt.partOfSpeech);
    },
    wordLevel(currentWord) {
      var level = this.$store.getters.wordSRS(this.prompt);
      return level;
    },
    randomDeclensionNumber() {
      return Math.floor(
        Math.random() * Object.keys(this.prompt.declensions).length
      );
    },
    declensions() {
      return Object.values(this.prompt.declensions).map((d) => d.toLowerCase());
    },
    randomDeclensionPrompt() {
      return Object.keys(this.prompt.declensions)[this.randomDeclensionNumber];
    },
    wordWithoutAccents(){
      return this.prompt.emiWord.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
  },
  filters: {
    camelToSpacedCaps: function (str) {
      const reg = /([a-z])([A-Z])/;
      return str.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
        return str.toUpperCase();
      });
    },
    lowercase: function (str) {
      return str.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>